module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "documents-layout ctn-patrimonial-landscape"
  }, [_c('article', [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\tDocuments archivés\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "view-nav-template white-box row"
  }, [_c('div', {
    staticClass: "menu column"
  }, [_c('ul', {
    staticClass: "ctn-menu column"
  }, _vm._l((_vm.menu), function(item, key) {
    return _c('li', {
      key: key,
      staticClass: "item-main",
      class: {
        active: _vm.isActiveFirst(key)
      }
    }, [_c('div', {
      staticClass: "label",
      domProps: {
        "innerHTML": _vm._s(item.label)
      },
      on: {
        "click": function($event) {
          return _vm.setActiveFirst(key)
        }
      }
    }), _vm._v(" "), (item.children && _vm.isActiveFirst(key)) ? _c('ul', {
      staticClass: "ctn-second"
    }, _vm._l((item.children), function(child, keyt) {
      return _c('li', {
        key: keyt,
        staticClass: "item-second",
        class: {
          active: _vm.isActiveSecond(keyt)
        },
        domProps: {
          "innerHTML": _vm._s(child.label)
        },
        on: {
          "click": function($event) {
            return _vm.setActiveSecond(keyt)
          }
        }
      })
    }), 0) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "view column"
  }, [_c('div', {
    staticClass: "title row"
  }, [_c('div', {
    staticClass: "inner-title",
    domProps: {
      "innerHTML": _vm._s(_vm.menu[_vm.activeFirstLevel].label)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        _vm.showAddDocument = true
      }
    }
  }, [_vm._v("Ajouter un document")])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-component"
  }, [(_vm.drawComponent) ? _c(_vm.currentComponent, {
    ref: "currentComp",
    tag: "component"
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('base-modal', {
    attrs: {
      "content": _vm.modalAddDocument,
      "show": _vm.showAddDocument
    },
    on: {
      "close": _vm.resolveCloseAddDocument
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3768e408"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Transactions/Documents.vue
// module id = 1100
// module chunks = 0